import { BusinessOutlined } from '@mui/icons-material'
import { Skeleton, useTheme } from '@mui/material'
import { useScreenSize } from '@front/components/hooks/useScreenSize'

type InstitutionHeaderLogoProps = {
  isLoading: boolean
  logoUrl?: string | null
}

export const InstitutionHeaderLogo = ({
  isLoading,
  logoUrl,
}: InstitutionHeaderLogoProps) => {
  const theme = useTheme()
  const { isSmallScreen } = useScreenSize()

  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        width="100%"
        height="100%"
        data-testid="institution-header-logo-loading"
      />
    )
  }

  if (!logoUrl) {
    return <BusinessOutlined sx={{ color: theme.palette.text.disabled }} />
  }

  return (
    <img
      width={isSmallScreen ? 72 : 120}
      height={isSmallScreen ? 72 : 120}
      src={logoUrl}
      alt="logo"
    />
  )
}
